import { FuelCheckbox, FuelGridItem, FuelIcon, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { BluredContent } from 'components/BluredContent';
import BaseTruckerInformation from 'components/TruckerListItem/BaseTruckerInformation';
import { CityDistrict, Destiny, Distance } from 'components/TruckerListItem/styled';
import { DESTINY_WIDTH_BREAKPOINT, dsTheme, LOCALIZATION_WIDTH_BREAKPOINT } from 'constants/styled.contants';
import React, { FC } from 'react';
import Picture from '../Picture';
import { TruckerInformationProps } from '../types';

const DesktopWrapper: FC<TruckerInformationProps> = (props) => {
  const { checkin, lastLocation, hasCheckin, truckerOrigin, selected, person, isLocked } = props;
  const showDestiny = window.innerWidth > DESTINY_WIDTH_BREAKPOINT;
  const showLocalization = window.innerWidth > LOCALIZATION_WIDTH_BREAKPOINT;

  function getGridCollum() {
    if (!showDestiny && showLocalization) {
      return 3;
    }
    if (!showLocalization) {
      return 4;
    }
    return 2;
  }

  return (
    <>
      <FuelGridItem lg={getGridCollum()}>
        <FuelFlex
          defaultProps={{
            flexDirection: 'row',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'km2',
            customPadding: `0 0 0 ${dsTheme.spacing.km4}`,
          }}
        >
          <FuelCheckbox
            disabled={isLocked}
            data-testid="checkbox-destktop-wrapper"
            checked={selected}
            onInput={(e) => {
              const { checked } = e.target as HTMLFuelCheckboxElement;

              props.onSelect?.(checked);
            }}
          />
          <FuelFlex defaultProps={{ alignItems: 'center' }}>
            {!!person?.alreadyNotified && <FuelIcon name="share" data-testid="shared-icon" />}
            <Picture {...props} />
          </FuelFlex>
        </FuelFlex>
      </FuelGridItem>
      <FuelGridItem lg={showDestiny ? 5 : 6}>
        <FuelFlex defaultProps={{ flexDirection: 'row', height: '109px', alignItems: 'center' }}>
          <BaseTruckerInformation {...props} />
        </FuelFlex>
      </FuelGridItem>
      {showLocalization && (
        <FuelGridItem lg={3}>
          <FuelFlex defaultProps={{ alignItems: 'flex-start', flexDirection: 'column', height: '100%' }}>
            {hasCheckin ? (
              <CityDistrict>
                <FuelTypography size="body-sm" color="neutral-strong" weight="medium">
                  <BluredContent blurContent={isLocked}>{truckerOrigin}</BluredContent>
                </FuelTypography>
                <Distance hasDistanceInfo={lastLocation.verified}>
                  {lastLocation.verified ? (
                    <>
                      <FuelIcon name="navigation-cursor" size="micro" iconStyle="filled" />
                      <FuelTypography size="caption" weight="bold" color="neutral-weak">
                        {Math.floor(lastLocation.distance)} km da carga
                      </FuelTypography>
                    </>
                  ) : (
                    <FuelTypography size="caption" weight="bold" color="neutral-weak">
                      distância não informada
                    </FuelTypography>
                  )}
                </Distance>
              </CityDistrict>
            ) : (
              <FuelFlex defaultProps={{ alignItems: 'center', height: '100%', justifyContent: 'center' }}>
                <FuelTag
                  label="sem check-in"
                  icon="navigation-cursor"
                  iconStyle="filled"
                  uppercase
                  data-testid="no-checkin-tag"
                />
              </FuelFlex>
            )}
          </FuelFlex>
        </FuelGridItem>
      )}
      {showDestiny && (
        <FuelGridItem lg={2} md={1}>
          <Destiny>
            <BluredContent blurContent={isLocked}>{checkin?.destination ? checkin?.destination : '-'}</BluredContent>
          </Destiny>
        </FuelGridItem>
      )}
    </>
  );
};

export default DesktopWrapper;
